import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServerUrlService } from './server-url.service';

interface ResBodyType<T = any> {
  success: boolean
  description: string
  data: T
}

@Injectable({
  providedIn: 'root'
})
export class ParametrosService {

  params: any;
  agendamentos: any;
  private nodeParams: any;

  constructor(
    private http: HttpClient,
    private serverUrlService: ServerUrlService
  ) {
    //this.loadNodeParams();
   }

  onLoadParams() {
    this.loadNodeParams();
    const body = {
      chaves: [
        'APP_COMPANY',
        'APP_TITLE',
        'APP_LOGO',
        'APP_THEME',
        'APP_TYPE',
        'APP_CANCEL',
        'APP_USUARIO_ID',
        'APP_OTIMUS_HOST',
        'APP_PATIENT_DEFAULT',
        'APP_START_TIME',
        'APP_START_ALERT',
        'STEP_PAGAMENTO',
        'APP_VET',
        'ENVIO_ENVIOEMAILS',
        'ASSUNTO_ENVIOEMAILS',
        'CORPOTEXT_ENVIOEMAILS',
        'CORPOHTML_ENVIOEMAILS',
        'AGENDAMENTO_PADRAO',
        'ASAAS_BASE_URL',
        'ASAAS_ACCESS_TOKEN',
        'MODELO_TERMO_LGPD',
        'OCULTAR_SOLICITANTE',
        'HIDE_COMPANY'
      ]
    };

    this.http.get(`${this.serverUrlService.getUrl()}/parametros/agendamento`)
    .subscribe((data) => {
      this.agendamentos = data;
    });
    return this.http.post(`${this.serverUrlService.getUrl()}/parametros/get`, body);
  }

  getParams(chave: string) {
    return this.params.find((fnd: any) => fnd.chave === chave);
  }

  setParams(data: any) {
    this.params = data;
  }

  getParamsAgendamento() {
    return this.agendamentos;
  }

  updateParams(listParam: any) {
    // Vai passar um array com chave e valor a ser atualizado.
    return this.http.put(`${this.serverUrlService.getUrl()}/parametros/multi`, listParam);
  }

  loadFeriados() {
    return this.http.get(`${this.serverUrlService.getUrl()}/parametros/feriados`);
  }

  getTermos (body: any) {
    return this.http.post<ResBodyType<any>>(`${this.serverUrlService.otimusUrl}/modelodocumento/get`, body)
  }

  private loadNodeParams(): void {
    const body = {
      keys: [
        "REC_NODE_HOST",
        "REC_NODE_PORT",
        "REC_NODE_SECURE",
        "REC_NODE_BASEURL",
        "REC_NODE_SERVER"
      ]
    }
    this.http.post(`${this.serverUrlService.getUrl()}/parametros/varsys/get`, body)
    .subscribe((data) => {
      this.nodeParams = data;
    });
  }

  public getNodeParams(key: string): any {
    return this.nodeParams.find(item => item.param === key).value
  }

  getConvenioParams(convenioId: number | string) {
    return this.http.get<ResBodyType>(`${this.serverUrlService.otimusUrl}/parametros/convenio/${convenioId}`)
  }
}
